<template>
	<HFWrapper @isNewUi="v => setNewUiflag(v)">
		<div :class="['m_' + currentRoute, 'mobile_wrap', { sub_page, m_terms }]">
			<div v-if="!isNewUi">
				<Header></Header>
			</div>
			<router-view></router-view>
			<div v-if="!isNewUi">
				<FooterM></FooterM>
			</div>
		</div>
	</HFWrapper>
</template>

<script>
import Header from '@/components/Layout/Header.m';
import FooterM from '@/components/Layout/Footer.m';
import HFW from '../NewUi/Layout/HFW.vue';
export default {
	name: 'Layout.m',
	components: {
		Header,
		FooterM,
		HFWrapper: HFW,
	},
	data: () => ({
		isNewUi: false,
	}),
	props: {
		sub_page: {
			default: false,
			type: Boolean,
		},
		m_terms: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
	},
	methods: {
		setNewUiflag(v) {
			this.isNewUi = v;
		},
	},
};
</script>
